"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../../../common/constants/states");
var StudentLocationsCreateResidenceController = /** @class */ (function () {
    function StudentLocationsCreateResidenceController($state, $scope, UsersModel, UserService, FlashService) {
        this.$state = $state;
        this.$scope = $scope;
        this.UsersModel = UsersModel;
        this.UserService = UserService;
        this.FlashService = FlashService;
        this.states = states_1.States;
        this.pickuplocation = {
            name: "",
            street: "",
            city: "",
            state: "",
            zip: "",
        };
        this.student = UserService.getCurrentUser();
        this.hasPickupLocation = false;
        this.submitted = false;
    }
    StudentLocationsCreateResidenceController.prototype.submitPickupLocation = function () {
        var _this = this;
        var location = this.pickuplocation;
        this.submitted = true;
        this.UsersModel.addPickupLocation({
            student_id: this.student.id,
            pickuplocation: {
                name: location.name,
                street: location.street,
                city: location.city,
                state: location.state,
                zip: location.zip,
            },
        })
            .then(function (response) {
            var type = "success";
            if (response.message ===
                "Your pick up location was not in the school's service area. Your pick up location is the driving school.") {
                type = "info";
            }
            _this.FlashService.setMessage({
                type: type,
                message: response.message,
            });
            if (type === "info") {
                //dont change state until info alert is closed
                _this.$scope.$on("MESSAGE_CLEARED", function () {
                    _this.submitted = false;
                    _this.$state.go("drivecoach.student.dashboard.locations.index", {}, { reload: true });
                });
            }
            else {
                _this.submitted = false;
                _this.$state.go("drivecoach.student.dashboard.locations.index", {}, { reload: true });
            }
        })
            .catch(function (Error) {
            _this.submitted = false;
        });
    };
    return StudentLocationsCreateResidenceController;
}());
StudentLocationsCreateResidenceController.$inject = [
    "$state",
    "$scope",
    "UsersModel",
    "UserService",
    "FlashService",
];
exports.default = StudentLocationsCreateResidenceController;
